exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".comment .comment-content[data-v-194ab506]{position:relative}.comment .comment-content .count[data-v-194ab506]{font-size:12px;position:absolute;color:#929ca9;right:24px;bottom:10px;cursor:auto}.comment .comment-content .count #length[data-v-194ab506]{display:inline-block;width:30px;text-align:right}.comment .comment-textarea[data-v-194ab506]{width:100%;height:280px;font-size:14px;padding:26px 24px;resize:none;box-sizing:border-box;overflow:hidden;border:1px solid #e6e6e6;outline:none}.comment .warn[data-v-194ab506]{color:red!important}", ""]);

// exports
